export function randomExtend(minNum, maxNum) {
  if (arguments.length === 1) {
    return parseInt(Math.random() * minNum + 1, 10)
  } else {
    return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
  }
}

export function debounce(delay, callback) {
  let lastTime

  return function() {
    clearTimeout(lastTime)

    const [that, args] = [this, arguments]

    lastTime = setTimeout(() => {
      callback.apply(that, args)
    }, delay)
  }
}

export function observerDomResize(dom, callback) {
  const MutationObserver =
    window.MutationObserver ||
    window.WebKitMutationObserver ||
    window.MozMutationObserver

  const observer = new MutationObserver(callback)

  observer.observe(dom, {
    attributes: true,
    attributeFilter: ['style'],
    attributeOldValue: true
  })

  return observer
}

export function getPointDistance(pointOne, pointTwo) {
  const minusX = Math.abs(pointOne[0] - pointTwo[0])

  const minusY = Math.abs(pointOne[1] - pointTwo[1])

  return Math.sqrt(minusX * minusX + minusY * minusY)
}

export function getMapScript({ ak }) {
  if (!global.BMap) {
    global.BMap = {}
    global.BMap._preloader = new Promise((resolve, reject) => {
      global._initBaiduMap = function() {
        resolve(global.BMap)
        global.document.body.removeChild($script)
        global.BMap._preloader = null
        global._initBaiduMap = null
      }
      const $script = document.createElement('script')
      global.document.body.appendChild($script)
      // $script.src = `https://api.map.baidu.com/api?v=3.0&ak=${ak}&callback=_initBaiduMap`
      $script.src = `https://api.map.baidu.com/api?v=1.0&type=webgl&ak=${ak}&callback=_initBaiduMap`
    }) //api.map.baidu.com/api?type=webgl&v=1.0&ak=
    return global.BMap._preloader
  } else if (!global.BMap._preloader) {
    return Promise.resolve(global.BMap)
  } else {
    return global.BMap._preloader
  }
}


var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
var _typeof2 = _interopRequireDefault(require('@babel/runtime/helpers/typeof'))
/**
 * @description Clone an object or array
 * @param {Object|Array} object Cloned object
 * @param {Boolean} recursion   Whether to use recursive cloning
 * @return {Object|Array} Clone object
 */
export function deepClone(object) {
  var recursion =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false
  if (!object) return object
  var parse = JSON.parse,
    stringify = JSON.stringify
  if (!recursion) return parse(stringify(object))
  var clonedObj = object instanceof Array ? [] : {}

  if (object && (0, _typeof2['default'])(object) === 'object') {
    for (var key in object) {
      if (object.hasOwnProperty(key)) {
        if (object[key] && (0, _typeof2['default'])(object[key]) === 'object') {
          clonedObj[key] = deepClone(object[key], true)
        } else {
          clonedObj[key] = object[key]
        }
      }
    }
  }

  return clonedObj
}


export function deepMerge(target, merged) {
  for (var key in merged) {
    if (target[key] && (0, _typeof2['default'])(target[key]) === 'object') {
      if (key === 'data') {
        target[key] = (0, deepClone)(merged[key], true)
      } else {
        deepMerge(target[key], merged[key])
      }
      // deepMerge(target[key], merged[key]);
      continue
    }

    if ((0, _typeof2['default'])(merged[key]) === 'object') {
      target[key] = (0, deepClone)(merged[key], true)
      continue
    }

    target[key] = merged[key]
  }

  return target
}
